/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_KeineangabeInputs */

const en__field_enum_keineangabe = /** @type {(inputs: _Field_Enum_KeineangabeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`prefer not to say`)
};

const de__field_enum_keineangabe = /** @type {(inputs: _Field_Enum_KeineangabeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`keine Angabe`)
};

/**
* | output |
* | --- |
* | "prefer not to say" |
*
* @param {_Field_Enum_KeineangabeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_enum_keineangabe = /** @type {((inputs?: _Field_Enum_KeineangabeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_KeineangabeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_keineangabe(inputs)
	return de__field_enum_keineangabe(inputs)
});